<script>
export default {
  name: "IconCopy"
};
</script>

<template>
  <svg width="10" height="12" viewBox="0 0 10 12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 2.743h1.333V1.029c0-.563.454-1.029 1-1.029H9c.547 0 1 .466 1 1.029v7.2c0 .562-.453 1.028-1 1.028H7.667v1.714c0 .563-.454 1.029-1 1.029H1c-.547 0-1-.466-1-1.029v-7.2c0-.562.453-1.028 1-1.028ZM7.667 3.77V8.23H9v-7.2H3.333v1.714h3.334c.546 0 1 .466 1 1.028ZM1 10.971h5.667v-7.2H1v7.2Z"
      fill="currentColor"
      fill-rule="nonzero"
    />
  </svg>
</template>
